export class RequestTimeoutError extends Error {
  constructor(timeoutMS: number) {
    super(`Request timed out after ${timeoutMS}ms.`);
    this.name = "RequestTimeoutError";
  }
}

export const fetchWithTimeout = async (
  input: RequestInfo,
  init?: RequestInit | undefined,
  timeoutMS = 8000,
) => {
  const controller = new AbortController();
  const timeoutError = new RequestTimeoutError(timeoutMS);
  const requestSignal = init?.signal;
  const abortFromRequestSignal = () => {
    controller.abort(requestSignal?.reason);
  };

  if (requestSignal?.aborted) {
    controller.abort(requestSignal.reason);
  } else if (requestSignal) {
    requestSignal.addEventListener("abort", abortFromRequestSignal, {
      once: true,
    });
  }

  const timeout = setTimeout(() => {
    controller.abort(timeoutError);
  }, timeoutMS);

  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } catch (error) {
    if (
      controller.signal.aborted &&
      controller.signal.reason === timeoutError
    ) {
      throw timeoutError;
    }

    throw error;
  } finally {
    clearTimeout(timeout);
    requestSignal?.removeEventListener("abort", abortFromRequestSignal);
  }
};
